import {StateService} from '../service/state.service';
import {Component, forwardRef, OnInit} from '@angular/core';
import {DropdownFormControl} from '../dropdown-form-control/dropdown-form-control';
import {ControlContainer, FormGroupDirective, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'app-state-dropdown',
    templateUrl: 'state-dropdown.component.html',
    styleUrls: ['state-dropdown.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => StateDropdownComponent),
        multi: true
    }],
    viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}]
})
export class StateDropdownComponent extends DropdownFormControl<string> implements OnInit {
    private readonly stateService: StateService;

    constructor(stateService: StateService) {
        super();
        this.stateService = stateService;
    }

    public async ngOnInit(): Promise<void> {
        const states = await this.stateService.getAll();
        this.allValues = states.map(s=>s.name);
    }
}
